import { render, staticRenderFns } from "./FeatureNudge.vue?vue&type=template&id=60dbc7a0&scoped=true"
import script from "./FeatureNudge.vue?vue&type=script&lang=js"
export * from "./FeatureNudge.vue?vue&type=script&lang=js"
import style0 from "./FeatureNudge.vue?vue&type=style&index=0&id=60dbc7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dbc7a0",
  null
  
)

export default component.exports